import { h } from 'preact'
import styles from './footer.module.css'

import { format } from 'date-fns'
import { nb } from 'date-fns/locale'

export const Published = ({ meta }) => {
  const published = meta && meta.published && (
    <div>
      Publisert <span class={styles.date}>{getDate(meta.published)}</span>
    </div>
  )
  const updated = meta && meta.updated && (
    <div>
      Oppdatert <span class={styles.date}>{getDate(meta.updated)}</span>
    </div>
  )
  return (
    <div className={styles.published}>
      {published}
      {updated}
    </div>
  )
}

function getDate(date) {
  return format(new Date(date), 'd. MMMM y HH:mm', { locale: nb })
}
